import useSWR from 'swr'
import GLOBALSTORAGE from '../globalstorage'

type NotificationType = { title?: string; info?: string; isFailure?: boolean }

export default () => {
	return useSWR<NotificationType>(GLOBALSTORAGE.POPUP_NOTIFICATION)
}
